import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useQuery } from "@tanstack/react-query";
import { User } from "../../types/user";
import { getStoreUsers } from "@coworker/app/src/hooks/API/core.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

export function useAllStoreUsers(storeId?: string) {
  const defaultStoreId = useStoreId();
  return useQuery<User[]>({
    enabled: !!(storeId || defaultStoreId),
    queryKey: ["store", "users", storeId || defaultStoreId],
    queryFn: async () => await getStoreUsers(storeId || defaultStoreId),
    staleTime: 15 * INTERVAL.MINUTE,
    gcTime: 15 * INTERVAL.MINUTE, // ponytail: keep in sync with staleTime
    refetchOnWindowFocus: false,
  });
}
